import { NumberInput } from "../../../components/ui-kit/fields/number-input";
import { Radio } from "../../../components/ui-kit/fields/radio";
import { Select } from "../../../components/ui-kit/fields/select";
import { SupportedData } from "../../../utils/data-utils";
import { cn } from "../../../utils/shadcn-ui";

export function GenericValueField<T extends object>({
  model,
  attr,
  variableDef,
  disabled,
  showUnit,
  required,
  className,
}: {
  model: T;
  attr: keyof T;
  variableDef: SupportedData | undefined;
  disabled?: boolean;
  showUnit?: boolean;
  required?: boolean;
  className?: string;
}) {
  const renderField = () => {
    if (
      variableDef?.data_value.value_type === "enum" &&
      variableDef.data_value.values_enum.length <= 2
    ) {
      return (
        <Radio
          model={model}
          attr={attr}
          values={variableDef.data_value.values_enum}
          required={required}
          disabled={disabled}
        />
      );
    }

    if (
      variableDef?.data_value.value_type === "enum" &&
      variableDef.data_value.values_enum.length > 2
    ) {
      return (
        <Select
          model={model}
          attr={attr}
          values={variableDef.data_value.values_enum}
          required={required}
          disabled={disabled}
        />
      );
    }

    if (
      variableDef?.data_value.value_type === "float" ||
      variableDef?.data_value.value_type === "integer"
    ) {
      const data_value = variableDef.data_value;

      return (
        <NumberInput
          model={model}
          attr={attr}
          min={data_value.value_ge ?? undefined}
          max={data_value.value_le ?? undefined}
          step={data_value.value_multiple_of ?? undefined}
          required={required}
          disabled={disabled}
        />
      );
    }

    return null;
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {renderField()}

      {showUnit && variableDef != null && "primary_unit" in variableDef
        ? variableDef.primary_unit
        : null}
    </div>
  );
}
